export default "__VITE_ASSET__CReeNF3Y__"